import * as React from 'react';

export interface AppContextAccount {
  id: number;
  screenId: string;
  name: string;
  department: string;
  authority: {
    level: number;
  };
  created: Date;
}

export interface AppContextAppInfo {
  companyName: string;
}

type Action =
  | { type: 'setAccount'; account: AppContextAccount }
  | { type: 'setAppInfo'; appInfo: AppContextAppInfo }
  | { type: 'removeAccount' };

export function appContextReducer(
  state: AppContextState,
  action: Action
): AppContextState {
  switch (action.type) {
    case 'setAccount':
      return { ...state, me: action.account };
    case 'removeAccount':
      return { ...state, me: undefined };
    case 'setAppInfo':
      return { ...state, appInfo: action.appInfo };
    default:
      return state;
  }
}

export interface AppContextState {
  me?: AppContextAccount;
  appInfo?: AppContextAppInfo;
}

interface IAppContext {
  ready: boolean;
  state: AppContextState;
  dispatch: React.Dispatch<Action>;
}

export const AppContext = React.createContext<IAppContext>({
  ready: false,
  state: {},
  dispatch() {
    throw new Error('AppContext is not initialized');
  },
});
